import "../scss/style.scss";

/**
 * @babel/polyfill の利用
 * ※ PromiseやArray.includes()など、構文ではない機能的な仕様を利用するために必要
 */
import "@babel/polyfill";

import lazysizes from "lazysizes"
import unveil from "lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js"

// if ('NodeList' in window && !NodeList.prototype.forEach) {
//     NodeList.prototype.forEach = function (callback, thisArg) {
//         thisArg = thisArg || window;
//         for (var i = 0; i < this.length; i++) {
//             callback.call(thisArg, this[i], i, this);w
//         }
//     };
// }

import Headroom from "./lib/Headroom";
import ResponsiveImages from "./lib/ResponsiveImages";
import Drawer from "./lib/Drawer";
import FixNav from "./lib/FixNav";
import Accordion from "./lib/Accordion";
import switchViewport from "./lib/switchViewport";
//import inputCheckbox from "./lib/inputCheckbox";
import List from "./lib/List";

new Headroom();
new ResponsiveImages();
new Drawer();
new FixNav();
new Accordion();
new switchViewport();
//new inputCheckbox();
new List();